import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Header } from "../../../components/header";
import { CardHeader } from "../../../components/cards";
import { SendIcon } from "../../../components/icons";
import { ArticleForm } from "../components";

export const CreateArticle: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const customerId = searchParams.get("customerId");

  return (
    <>
      <Header
        title="Article"
        subtitle="Créer un nouvel article"
        buttons={[
          {
            actionText: "Annuler",
            bgColor: "indigo",
            textColor: "white",
            link: `/articles`,
            icon: <SendIcon />,
          },
        ]}
      />
      <div className="main-container">
        <div className="card">
          <CardHeader title="Nouvel article" />
          <ArticleForm
            customerId={customerId ? +customerId : undefined}
            onCompleted={() => navigate("/articles")}
          />
        </div>
      </div>
    </>
  );
};
